module.exports = __webpack_public_path__ + "media/images/big/img6-58234d565d0c7ae1fc762eed7033966a.jpg";